module.exports = __webpack_public_path__ + "img/alert-banner.7943ac1f.png";